import { useCallback, useEffect, useRef } from "react";
import { appInsightsTrackEvent } from "plugins/app-insight-init";
import { getCurrentLocalTime } from "common/date-utils";
import { setNavigationLoading } from "../store/workspaces";
export const useWorkspaceNavigation = ({ selectedSection, selectedType, pathInformations, workspace, currentDashboardType, dispatch, changeUrl }) => {
    const navDebounceRef = useRef(null);
    const navStartTimeRef = useRef(null);
    const DEBOUNCE_MS = 50;
    const handleChangePage = useCallback((sourceItem) => {
        const nextSection = sourceItem?.detail?.element?.value?.newSection;
        if (!nextSection || nextSection === selectedSection) {
            return;
        }
        try {
            appInsightsTrackEvent({ name: "WorkspaceNavigationAttempt", properties: { LocalTimestamp: getCurrentLocalTime() } }, { fromSection: selectedSection, pane: selectedType, toSection: nextSection });
        }
        catch {
            // Noop
        }
        if (navDebounceRef.current) {
            window.clearTimeout(navDebounceRef.current);
        }
        navStartTimeRef.current = typeof performance !== "undefined" && performance.now ? performance.now() : Date.now();
        dispatch(setNavigationLoading(true));
        navDebounceRef.current = window.setTimeout(() => {
            changeUrl(sourceItem, pathInformations, workspace, currentDashboardType, dispatch);
        }, DEBOUNCE_MS);
    }, [selectedSection, selectedType, pathInformations, workspace, currentDashboardType, dispatch, changeUrl]);
    useEffect(() => {
        if (navStartTimeRef.current !== null) {
            const end = typeof performance !== "undefined" && performance.now ? performance.now() : Date.now();
            const durationMs = Math.round(end - navStartTimeRef.current);
            navStartTimeRef.current = null;
            try {
                appInsightsTrackEvent({ name: "WorkspaceNavigationComplete", properties: { LocalTimestamp: getCurrentLocalTime() } }, { durationMs, pane: selectedType, section: selectedSection });
            }
            catch {
                // Noop
            }
            dispatch(setNavigationLoading(false));
        }
        return () => {
            if (navDebounceRef.current) {
                window.clearTimeout(navDebounceRef.current);
                navDebounceRef.current = null;
            }
        };
    }, [dispatch, selectedSection, selectedType]);
    return { handleChangePage };
};
